/** Sell rate that gives `margin` % of the sell price as profit: cost / (1 - margin). Blank when there is no cost or no usable margin. */
export const priceFromCost = (cost, margin) => {
  const m = Number(margin) || 0;
  return cost > 0 && m > 0 && m < 100 ? Math.round((cost / (1 - m / 100)) * 100) / 100 : "";
};

/** When a line's cost changes, its sell rate follows - but only if that rate was worked out from the old cost (or is still empty).
 *  A rate somebody typed themselves is left alone: it was a decision, not a calculation.
 *  Returns the rate the line should now have (the same value when it should not change). */
export function rateAfterCostChange(rate, oldCost, newCost, margin) {
  const m = Number(margin);
  if (!(m > 0 && m < 100) || !(newCost > 0)) return rate;
  const empty = !Number(rate);
  const wasDerived = oldCost > 0 && Math.abs(Number(rate) - Number(priceFromCost(oldCost, m))) < 0.015;
  return empty || wasDerived ? priceFromCost(newCost, m) : rate;
}
